import { HttpParams } from '@angular/common/http';

export function createWebSocketUrl(path: string, params: HttpParams): string {
  const normalizedPath = path.startsWith('http') ? path.replace('http', 'ws') : `ws://${window.location.host}${path}`;

  return params.toString() ? `${normalizedPath}?${params.toString()}` : `${normalizedPath}`;
}
